export default {
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR',
  SET_REPORTS: 'SET_REPORTS',
  SET_PRODUCTS: 'SET_PRODUCTS',
  SET_MY_REPORTS: 'SET_MY_REPORTS',
  SET_SUCCESS_MESSAGE: 'SET_SUCCESS_MESSAGE',
};
